import { Breadcrumbs, Link, Typography } from "@mui/material";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import FormContainer from "../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { useAuditoresCadastroViewModel } from "../../viewModels/auditores_cadastro_view_model";
import { FormPhoneMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_phone_masked_input";
import BottomBar from "../../../../../common/components/bottom_bar";
import RefreshButton from "../../../../../common/components/refresh_button";
import { BackButton } from "../../../../../common/components/back_button";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";
import { DefaultFormDownloadInput } from "../../../../../common/components/default_form_download_input";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";

export const AuditoresCadastro = () => {
  const viewModel: any = useAuditoresCadastroViewModel();

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={<BackButton onClick={viewModel.handleVoltarOpenState} />}
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Auditoria
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Auditores
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Cadastro de Auditores
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
            <FormContainer title={"Informações Gerais"} arrangement="fullRow">
              <>
                <div className="flex flex-row gap-x-8">
                  <div className="flex items-center justify-start py-2">
                    <FormRadioGroupInput
                      name="TipoAuditor"
                      label="Tipo Auditor"
                      readOnly={viewModel.saving}
                      options={[
                        { id: 0, label: "Interna" },
                        { id: 1, label: "Externa" },
                      ]}
                      reactHookForm={viewModel.hookFormAuditores}
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row gap-x-8">
                  <DefaultFormInput
                    name="Nome"
                    label="Nome"
                    required={true}
                    reactHookForm={viewModel.hookFormAuditores}
                  />
                  <FormPhoneMaskedInput
                    name="TelCelular"
                    type="movel"
                    label="Tel. Celular"
                    reactHookForm={viewModel.hookFormAuditores}
                  />
                </div>
                <div className="flex flex-row gap-x-8">
                  <DefaultFormInput
                    name="Email"
                    label="Email"
                    reactHookForm={viewModel.hookFormAuditores}
                  />

                  <FormPhoneMaskedInput
                    name="TelFixo"
                    type="movel"
                    label="Tel. Fixo"
                    reactHookForm={viewModel.hookFormAuditores}
                  />
                </div>
                <DefaultFormInput
                  name="Cidade"
                  label="Cidade"
                  reactHookForm={viewModel.hookFormAuditores}
                />
              </>
            </FormContainer>
            <FormContainer title={"Outras informações"} arrangement="fullRow">
              <>
                <DefaultFormInput
                  name="OutrasInformacoes"
                  label="Outras Informacoes"
                  rows={4}
                  multiline={true}
                  reactHookForm={viewModel.hookFormAuditores}
                />
              </>
            </FormContainer>
            <FormContainer title={"Anexar documento"} arrangement="fullRow">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
                <DefaultFormDownloadInput
                  name="Arquivo1"
                  nameLimparFlag="limparArquivo1"
                  saving={viewModel.saving}
                  filename={viewModel.selectedAuditores?.nomeArquivo1 ?? null}
                  reactHookForm={viewModel.hookFormAuditores}
                  onDownloadFile={(filename) =>
                    viewModel.handleDownloadFile(filename, 1)
                  }
                  onDeleteFile={() => viewModel.handleFileChange(1)}
                />

                <DefaultFormDownloadInput
                  name="Arquivo2"
                  nameLimparFlag="limparArquivo2"
                  saving={viewModel.saving}
                  filename={viewModel.selectedAuditores?.nomeArquivo2 ?? null}
                  reactHookForm={viewModel.hookFormAuditores}
                  onDownloadFile={(filename) =>
                    viewModel.handleDownloadFile(filename, 2)
                  }
                  onDeleteFile={() => viewModel.handleFileChange(2)}
                />
                <DefaultFormDownloadInput
                  name="Arquivo3"
                  nameLimparFlag="limparArquivo3"
                  saving={viewModel.saving}
                  filename={viewModel.selectedAuditores?.nomeArquivo3 ?? null}
                  reactHookForm={viewModel.hookFormAuditores}
                  onDownloadFile={(filename) =>
                    viewModel.handleDownloadFile(filename, 3)
                  }
                  onDeleteFile={() => viewModel.handleFileChange(3)}
                />
                <DefaultFormDownloadInput
                  name="Arquivo4"
                  nameLimparFlag="limparArquivo4"
                  saving={viewModel.saving}
                  filename={viewModel.selectedAuditores?.nomeArquivo4 ?? null}
                  reactHookForm={viewModel.hookFormAuditores}
                  onDownloadFile={(filename) =>
                    viewModel.handleDownloadFile(filename, 4)
                  }
                  onDeleteFile={() => viewModel.handleFileChange(4)}
                />
                <DefaultFormDownloadInput
                  name="Arquivo5"
                  nameLimparFlag="limparArquivo5"
                  saving={viewModel.saving}
                  filename={viewModel.selectedAuditores?.nomeArquivo5 ?? null}
                  reactHookForm={viewModel.hookFormAuditores}
                  onDownloadFile={(filename) =>
                    viewModel.handleDownloadFile(filename, 5)
                  }
                  onDeleteFile={() => viewModel.handleFileChange(5)}
                />
              </div>
            </FormContainer>
          </div>
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.idAuditor) && (
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}
                >
                  <span className="text-xs">Historico de alterações</span>
                </PrimaryButton>
              )}
            </div>
            <div className="flex flex-row gap-4 ml-auto">
              <div
                className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold"
                onClick={() => viewModel.handleVoltarOpenState()}
              >
                <h1 className="text-sm text-black dark:text-white">Cancelar</h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    onClick={viewModel.hookFormAuditores.handleSubmit(
                      viewModel.handleAuditorlSubmit,
                    )}
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
    </>
  );
};
